var map = {
	"./custom/custom_logo.svg": "3936",
	"./custom/custom_logo_white.svg": "3cc1",
	"./default/SPEDIMO_logo.svg": "7042",
	"./default/SPEDIMO_logo_white.svg": "bd59"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7338";